import styled from 'styled-components'
import Icon from '@mdi/react'

import theme from 'theme_'
import { CommonLink } from 'components/Button'
import { H3 } from 'components/Typography'

const { spacing, colors } = theme

export const SubsDetailsHeading = styled(H3)`
  margin-bottom: ${spacing.base};
`

export const SubsDetailsPlanBlock = styled.div`
  display: flex;
  border-radius: ${spacing.xs};
  background-color: ${colors.white};
  animation: ${theme.animations.fadeIn} 0.3s ease;
`

export const SubsDetailsPlanImage = styled.div`
  display: none;
  position: relative;
  z-index: 1;
  width: 50%;
  flex-basis: 50%;
  flex-grow: 1;
  flex-shrink: 1;
  justify-content: center;
  align-items: center;
  padding: ${spacing.base} ${spacing.base} ${spacing.md};

  @media ${theme.devices.tablet} {
    display: flex;
  }

  &:before {
    content: '';
    position: absolute;
    top: ${spacing.base};
    left: -1px;
    display: block;
    width: 1px;
    height: calc(100% - (${spacing.base} * 2));
    background-color: ${colors.lightGrey};
  }
`

export const SubsDetailsBackLink = styled(CommonLink)`
  display: inline-flex;
  align-items: center;
  margin-bottom: ${spacing.sm};
  font-weight: 700;
  color: ${colors.horizonOrange};
`
export const SubsDetailsBackIcon = styled(Icon)`
  margin-right: ${spacing.base};
`
export const PurchaseSubscriptionMainBlock = styled.div`
  display: flex;
  flex-flow: wrap row;
  justify-content: space-between;
  gap: 8px;
`

export const PurchaseSubscriptionSubBlock = styled.div`
  display: flex;
  flex-flow: wrap column;
  justify-content: space-between;
  gap: 8px;
  max-width: 800px;

  @media ${theme.devices.mobile} {
    flex-flow: column;
  }
`
